import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PHOTO_PICKER_MODEL } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import { DELIVERY_ASSET_TYPE, DELIVERY_MODEL } from '../Model/Model';
import HandleChange from '../../../../../Helpers/HandleChange';
import { USER_TYPE_MODEL } from '../../../../../enums/userTypeEnum';
import {
    CreateDelivery,
    CreateDeliveryAsset,
    GetDeliveryById
} from '../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { useDispatch } from 'react-redux';
import { errorMsg } from '../../../../../Apis/functions';
import { toast } from 'react-toastify';
import { STATUS_MODEL } from '../../../../../enums/statusEnum';
import { useParams } from 'react-router-dom';
import {base64ToFile} from "../../../../../utils/Base64ToBlob";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeliveryRecordModalApp = ({ onHide }) => {
    const { t } = useTranslation();
    const [emptyFields, setEmptyFields] = useState(false); // Indicates if required fields are empty
    const [disabled, setDisabled] = useState(false); // Controls disabled state of the form
    const [selectedList, setSelectedList] = useState([]); // List of selected items
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL }); // Photo picker state
    const [item, setItem] = useState({ ...DELIVERY_MODEL }); // Delivery record model state
    const { handleChange } = HandleChange({ model: item, setModel: setItem }); // Input change handler
    const dispatch = useDispatch();
    const { id } = useParams();
    const [displayModal, setDisplayModal] = useState('');
    const [clear, setClear] = useState(false);

    // Confirms the form submission
    const handleConfirm = async () => {
        const deliveryById = selectedList?.[0]?.id || null;

        if (!item.isValid(deliveryById)) {
            setEmptyFields(true);
            return;
        }

        const body = item.toRegister({
            equipmentId: id,
            deliveryById,
            statusId: STATUS_MODEL.PENDING_REVIEW,
        });

        try {
            const response = await dispatch(CreateDelivery(body)).unwrap();

            const { success, code, data: delivery } = response.data;

            if (!success) {
                errorMsg(code);
                return;
            }

            if(photoPicker?.fileSelected || photoPicker?.selfieSrc){
                const uploadFile = photoPicker?.fileSelected || base64ToFile(photoPicker?.selfieSrc, new Date().getTime());
                if(!uploadFile) return;
                const formData = new FormData();
                formData.append('id', delivery.id);
                formData.append('uploadType', DELIVERY_ASSET_TYPE.DELIVERY);
                formData.append('deliveryFile.files', uploadFile);
                formData.append('deliveryFile.userFileNames', uploadFile.name);
                await dispatch(CreateDeliveryAsset(formData));
            }

            toast.success(t('has_been_created_successfully'));
            await dispatch(GetDeliveryById(delivery.id))
            onHide();
        } catch (error) {
            errorMsg(error?.code);
        }
    };

    // Clears all form data
    const handleClear = () => {
        DELIVERY_MODEL.clear();
        setItem({ ...DELIVERY_MODEL });
        setSelectedList([]);
        setEmptyFields(false);
        setPhotoPicker({ ...PHOTO_PICKER_MODEL })
        setClear(true);
        setDisplayModal('');
    };
    // User type to filter/search
    const userTypeToSearch = USER_TYPE_MODEL.CONTRACTORS_EMPLOYEE;

    return {
        t,
        handleConfirm,
        handleClear,
        photoPicker,
        setPhotoPicker,
        emptyFields,
        disabled,
        item,
        handleChange,
        selectedList,
        userTypeToSearch,
        setSelectedList,
        displayModal,
        setDisplayModal,
        clear,
        setClear
    };
};

export default DeliveryRecordModalApp;
